import Button from "components/form/Button";
import PaymentMethodsComponent from "components/paymentMethod/PaymentMethodsComponent";
import CustomTooltip from "components/ui-component/CustomTooltip";
import WalletIcon from "icons/payments/WalletIcon";
import PaymentProcessStep2 from "pages/payments/PaymentProcessStep2";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { updateOverlayState } from "store/slices/authSlice";
import { useIsLogin } from "store/slices/commonSlice";
import {
  useBankData,
  useCardData,
  useIsDataLoading,
} from "store/slices/paymentMethodSlice";
import { AddCircleIconBlue } from "utils/icon";
import PaymentConfirmation from "./PaymentConfirmation";

import { FailedPaymentComponentProps } from "../../types/FailedPaymentTypes";
import { setIsPaymentProcessing } from "store/slices/paymentsSlice";
import { PaymentGateway } from "types/payments";
import { RootState } from "store/store";
import { useTid } from "utils/testid";
import { getUsableSavedPaymentMethods } from "utils/paymentMethodAvailability";
import { isStripeKeyMissing } from "utils/stripePublishableKey";
const FailedPaymentComponent = ({
  currentStep,
  isAddNewCard,
  setIsAddNewCard,
  dataPayment,
  setDataPayment,
  walletList,
  setSavedCardsEmail,
  paymentMethodList,
  setSelectedMethod,
  handleChangeCard = () => {},
  setSelectedState,
  cardNumber,
  selectedState,
  selectedMethod,
  iconType,
  isDateErr,
  handleChangeBank = () => {},
  numberNotmatchedError,
  setnumberNotmatchedError,
  bankName,
  errMsg,
  isRingLoading,
  email,
  setEmail,
  values,
  paymentDetails,
  validateCard = () => {},
  isErr,
  cardErrMsg,
  setValues = () => {},
  setGoogleTokenData,
  setCurrentStep = () => {},
  setCompletedSteps = () => {},
  createPayPalIntent = () => {},
  isGoogleLoading = false,
  setApplePaySecret = () => {},
  setApplePayOrder = () => {},
  setIsApplePay = () => {},
  isDisabled = false,
  isFeeLoading = false,
  isSecretLoading = false,
  futurePayment = false,
  BankComp = <></>,
  isManualForm,
  setIsManualForm,
  order_id,
}: FailedPaymentComponentProps) => {
  const tid = useTid();
  const isDataLoading = useIsDataLoading();
  const isLogin = useIsLogin();
  const dispatch = useAppDispatch();
  const oldCardData = useCardData();
  const oldBankData = useBankData();

  const { paymentPermission } = useAppSelector(
    (state: RootState) => state.payment
  );
  const isCardBlocked =
    selectedMethod === "Card" && isStripeKeyMissing(paymentPermission, "CC");
  const { hasUsableSavedMethods } = getUsableSavedPaymentMethods({
    cardList: oldCardData,
    bankList: oldBankData,
    walletList,
    paymentMethodList,
    paymentPermission,
  });
  return (
    <>
      <div
        data-testid={tid("failed-payment-method-step")}
        aria-label="Failed payment method step"
        className={`lg:text-xl text-base lg:h-fit h-full font-medium pb-10 ${
          currentStep === 1
            ? "lg:pb-0 "
            : "lg:block hidden lg:visible none lg:pb-4 lg:pt-1 "
        }`}
      >
        <div className="w-full flex justify-between items-center">
          <p
            className={`${
              currentStep === 1 ? "text-btnPrimaryActive" : "text-txtPrimary"
            } py-2`}
          >
            Payment method
          </p>
          {currentStep === 1 && (
            <span>
              {isAddNewCard ? (
                <p
                  role="button"
                  tabIndex={0}
                  aria-label="Add a new payment method"
                  data-testid={tid("failed-payment-add-new-method-button")}
                  onClick={() => {
                    dispatch(setIsPaymentProcessing(true));
                    setIsAddNewCard(false);
                  }}
                  className="flex gap-2 items-center cursor-pointer xl:text-sm text-xs  font-medium text-blue hover:!text-btnPrimaryHover"
                >
                  <AddCircleIconBlue /> Add New
                </p>
              ) : (
                hasUsableSavedMethods && (
                  <p
                    role="button"
                    tabIndex={0}
                    aria-label={
                      isLogin
                        ? "Select saved payment method"
                        : "Log in to select saved payment method"
                    }
                    data-testid={tid("failed-payment-saved-method-button")}
                    className=" xl:text-sm text-xs text-blue cursor-pointer flex gap-2 hover:!text-btnPrimaryHover items-center"
                    onClick={() => {
                      if (isLogin) {
                        dispatch(setIsPaymentProcessing(true));
                        setIsAddNewCard(true);
                      } else {
                        dispatch(updateOverlayState(true));
                      }
                    }}
                  >
                    {isLogin ? (
                      <>
                        <span>
                          <WalletIcon
                            aria-hidden="true"
                            className="group"
                            _className="group-hover:!fill-btnPrimaryHover"
                          />
                        </span>
                        Select saved method
                      </>
                    ) : (
                      <CustomTooltip
                        maxwidth="430px"
                        place="top"
                        id="saved-method"
                        content={`<div class="text-xs leading-[18px] font-normal">Log in to access your saved payment methods</div>`}
                      >
                        <span id="saved-method" className=" flex gap-2">
                          <span>
                            <WalletIcon
                              aria-hidden="true"
                              className="group"
                              _className="group-hover:!fill-btnPrimaryHover"
                            />
                          </span>
                          Select saved method
                        </span>
                      </CustomTooltip>
                    )}
                  </p>
                )
              )}
            </span>
          )}
        </div>
        <div
          className={`${window.innerWidth > 769 ? "answerSection1" : ""} ${
            currentStep === 1
              ? "open mt-3 pr-3"
              : ""
          } scrollbar-visiable scroll-cue`}
        >
          {isAddNewCard ? (
            <>
              <div>
                <PaymentProcessStep2
                  data={dataPayment}
                  setData={setDataPayment}
                  setCurrentStep={() => {}}
                  isDataLoading={isDataLoading}
                  currentStep={2}
                  walletList={walletList}
                  setSavedCardsEmail={setSavedCardsEmail}
                  isPaymentLink={true}
                  paymentMethodList={paymentMethodList}
                  setSelectedMethod={setSelectedMethod}
                />
              </div>
            </>
          ) : (
            <>
              <PaymentMethodsComponent
                cardData={{
                  cardNumber,
                  isDateErr,
                  isErr,
                  cardErrMsg,
                  handleChangeCard,
                  validateCard,
                  iconType,
                  setIsAddNewCardMakePayment: setIsAddNewCard,
                  isAddNewCardMakePayment: isAddNewCard,
                }}
                bankData={{
                  bankName,
                  numberNotmatchedError,
                  setnumberNotmatchedError,
                  handleChangeBank,
                  selectedState,
                  setSelectedState,
                  isManualForm,
                  setIsManualForm,
                }}
                paymentConfig={{
                  paymentMethodList,
                  selectedMethod,
                  setSelectedMethod,
                  amount: paymentDetails?.amount,
                  isPaymentLink: true,
                  isRecurring: false,
                  isRetry: true,
                  useStripeGooglePay: true,
                  retryOrderSlug: order_id,
                  // The shared form spaces its sections 40px apart on desktop,
                  // which reads as a gap inside a 680px drawer. Tightened here
                  // only, so other flows using this form are unaffected.
                  customClassName: "lg:!gap-6",
                }}
                paymentHandlers={{
                  handleGooglePay: (data: any, amount: any) => {
                    setValues((state: any) => ({
                      ...state,
                      x_payment_method: "GP",
                    }));
                    setSelectedMethod("Google Pay");
                    setGoogleTokenData(data);
                    setCurrentStep(2);
                    setCompletedSteps([0, 1]);
                  },
                  createPayPalIntent,
                  handleApplePay: (
                    secret: any,
                    event: any,
                    stripe: any,
                    elements: any
                  ) => {
                    setApplePaySecret(secret);
                    setApplePayOrder({
                      event,
                      stripe,
                      elements,
                    });
                    setIsApplePay(true);
                    setCurrentStep(2);
                    setCompletedSteps([0, 1]);
                  },
                }}
                paymentUrls={{}}
                formState={{
                  values,
                  email,
                  setEmail,
                  errMsg,
                  isRingLoading,
                }}
                paymentGatewayState={{
                  isGoogleLoading,
                }}
                componentRefs={{}}
                phoneAndAddressConfig={{}}
              />
              {!isCardBlocked && BankComp}
            </>
          )}

          {selectedMethod === "Card" &&
          !isAddNewCard &&
          paymentPermission?.cc_gateway_name?.name === PaymentGateway.STRIPE ? (
            <></>
          ) : (
            <>
              {(selectedMethod !== "PayPal" || isAddNewCard) && (
                // Pinned to the bottom of the scrolling method list rather than
                // sitting at the end of it. Choosing a card adds the fee line,
                // and on a viewport shorter than ~890px that pushed the only way
                // forward past the fold — at 1280x800 the button landed 187px
                // below the list's visible edge with no hint it was there. The
                // opaque background keeps the list from showing through it as it
                // scrolls underneath.
                <div className="w-full flex justify-end pt-8 sticky bottom-0 z-10 bg-white">
                  <Button
                    text="Next"
                    data-testid={tid("failed-payment-method-next-button")}
                    aria-label="Continue to payment confirmation"
                    className="!px-14"
                    isDisabled={
                      isDisabled || isFeeLoading || numberNotmatchedError
                    }
                    isLoading={isSecretLoading || isFeeLoading}
                    variant="variable"
                    onClick={() => {
                      setCurrentStep(2);
                      setCompletedSteps([0, 1]);
                    }}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* Line */}
      <div className="h-[1px] bg-strokeActive w-full lg:block hidden" />

      {/* Payment Confirmation */}
      <div className="lg:block hidden h-full w-full pb-[5px]">
        <PaymentConfirmation
          currentStep={currentStep}
          futurePayment={futurePayment}
          paymentDetails={paymentDetails}
          selectedMethod={selectedMethod}
          dataPayment={dataPayment}
          isAddNewCard={isAddNewCard}
          values={values}
          iconType={iconType}
        />
      </div>

      {currentStep === 2 && (
        <div className="lg:hidden block h-fit w-full">
          <PaymentConfirmation
            currentStep={currentStep}
            futurePayment={futurePayment}
            paymentDetails={paymentDetails}
            selectedMethod={selectedMethod}
            dataPayment={dataPayment}
            isAddNewCard={isAddNewCard}
            values={values}
            iconType={iconType}
          />
        </div>
      )}
    </>
  );
};

export default FailedPaymentComponent;
